import { useEffect, useRef } from 'react';

// Apollo `skipPollAttempt` option: skips scheduled poll requests while the tab is hidden to reduce backend load.
// Pair it with `useRefetchOnTabVisible` so the user gets fresh data as soon as they return to the tab.
export const skipPollAttemptWhenHidden = () => document.hidden;

export const useRefetchOnTabVisible = (refetch: () => unknown, active = true) => {
    const refetchRef = useRef(refetch);
    refetchRef.current = refetch;

    useEffect(() => {
        if (!active) return;

        const handleVisibilityChange = () => {
            if (document.hidden) return;
            Promise.resolve(refetchRef.current()).catch(() => undefined);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [active]);
};
